import * as React from 'react';
import { SectionHelper } from 'wix-style-react';
import { Trans } from 'react-i18next';
import s from '../SwitchPlanNotificationBar.scss';

export const PlanRemovedSectionHelper = ({ planName }) => {
  return (
    <div className={s.planRemoved}>
      <SectionHelper appearance='standard' showCloseButton={false}>
        <Trans
          i18nKey='change_plan.current_plan_modal.explanation_advanced'
          values={{
            planName,
          }}
        >
          <strong>{planName}</strong>
        </Trans>
      </SectionHelper>
    </div>
  );
};
